import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { OkeeyCardPausedContentComponent } from 'shared/components/okeey-card-paused-content/okeey-card-paused-content.component';

@Injectable({ providedIn: 'root' })
export class OkeeyCardStatusService {
  private readonly modalService = inject(NzModalService);
  private readonly translateService = inject(TranslateService);

  open(): void {
    this.modalService.warning({
      nzTitle: this.translateService.instant('balance.okeeyCardPausedTitle'),
      nzContent: OkeeyCardPausedContentComponent,
      nzOkText: null,
      nzCancelText: null,
      nzClassName: 'okeey-card-paused-modal',
      nzCentered: true
    });
  }
}
